import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./FloatingQuoteButton.css";

export default function FloatingQuoteButton() {
  const navigate = useNavigate();
  const [isExpanded, setIsExpanded] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  // Close when clicking outside (mobile)
  useEffect(() => {
    if (!isMobile || !isExpanded) return;

    const handleOutside = (e) => {
      if (!e.target.closest(".floating-quote-btn")) {
        setIsExpanded(false);
      }
    };
    document.addEventListener("click", handleOutside);
    return () => document.removeEventListener("click", handleOutside);
  }, [isMobile, isExpanded]);

  const handleClick = () => {
    if (isMobile) {
      if (!isExpanded) {
        setIsExpanded(true); // first tap → expand
      } else {
        navigate("/quote-request"); // second tap → go
      }
    } else {
      navigate("/quote-request"); // desktop → always navigate
    }
  };

  return (
    <button
      className={`floating-quote-btn ${isExpanded ? "is-expanded" : ""}`}
      onClick={handleClick}
      aria-label="Request today's rate"
    >
      {/* ₹ Bulge (always visible) */}
      <span className="floating-quote-btn__bulge">₹</span>

      {/* Text that slides out */}
      <span className="floating-quote-btn__text">Request today's rate</span>
    </button>
  );
}
